import { SET_OPENKEYS } from '../actions/MenuActions';

const INITIAL_STATE = { openKeys: [] };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_OPENKEYS:
      return { ...state, openKeys: action.payload };
    default:
      return state;
  }
}
